import { render, staticRenderFns } from "./dominio.vue?vue&type=template&id=deba21b0&"
import script from "./dominio.vue?vue&type=script&lang=js&"
export * from "./dominio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports